const ResponseToUserStore = (user) => {
  const {
    username,
    nombre,
    grupos,
    tipoUsuario,
    idVendor,
    idRep,
    fotoMiniatura: fotoPerfil,
    lastpasswordchange: ultimaModificacionPassword,
    diasvencimiento: diasVencimiento,
    fechaVencimiento
  } = user;
  return {
    username
    , nombre
    , grupos
    , tipoUsuario
    , idVendor
    , idRep
    , fotoPerfil
    , ultimaModificacionPassword
    , diasVencimiento
    , fechaVencimiento
  };
};

export default { ResponseToUserStore };



// WEBPACK FOOTER //
// ./src/helpers/transformations.js